import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconImageStackPlus24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconImageStackPlus24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13.468 9.5a4.5 4.5 0 0 0 3.032 2.389V18a1.5 1.5 0 0 1-1.022 1.422l-.053-.04-8-5.5-.467-.32-.436.36-3.022 2.5V11A1.5 1.5 0 0 1 5 9.5zM18 11.973V16.5a1.5 1.5 0 0 0 1.5-1.5v-3.468c-.46.23-.966.382-1.5.44m3-1.644A4.5 4.5 0 1 0 13.758 5H8a3 3 0 0 0-3 3 3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3 3 3 0 0 0 3-3zM13.111 6.5H8A1.5 1.5 0 0 0 6.5 8h6.528a4.5 4.5 0 0 1 .083-1.5M17.5 5a.75.75 0 0 0-.75.75v1h-1a.75.75 0 0 0 0 1.5h1v1a.75.75 0 1 0 1.5 0v-1h1a.75.75 0 0 0 0-1.5h-1v-1A.75.75 0 0 0 17.5 5M3.538 18.337A1.5 1.5 0 0 0 5 19.5h7.949l-5.907-4.061zM12.5 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 1.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconImageStackPlus24);
